const ClearhouseWaterData = {
  "checked": "2026-10-02",
  "coverage": "Utility-confirmed pilot; ZIP codes do not determine service boundaries.",
  "zipCountySource": "https://www2.census.gov/geo/docs/maps-data/data/rel2020/zcta520/tab20_zcta520_county20_natl.txt",
  "zipCountyBasis": "2020 Census ZCTA land intersections; county suggestions only, not utility service boundaries.",
  "zipCounties": {
    "33503": [
      "hillsborough"
    ],
    "33510": [
      "hillsborough"
    ],
    "33511": [
      "hillsborough"
    ],
    "33523": [
      "other",
      "pasco"
    ],
    "33525": [
      "pasco"
    ],
    "33527": [
      "hillsborough"
    ],
    "33530": [
      "hillsborough"
    ],
    "33534": [
      "hillsborough"
    ],
    "33540": [
      "hillsborough",
      "pasco"
    ],
    "33541": [
      "pasco"
    ],
    "33542": [
      "pasco"
    ],
    "33543": [
      "pasco"
    ],
    "33544": [
      "pasco"
    ],
    "33545": [
      "pasco"
    ],
    "33547": [
      "hillsborough",
      "other"
    ],
    "33548": [
      "hillsborough",
      "pasco"
    ],
    "33549": [
      "hillsborough",
      "pasco"
    ],
    "33550": [
      "hillsborough"
    ],
    "33556": [
      "hillsborough",
      "pasco"
    ],
    "33558": [
      "hillsborough",
      "pasco"
    ],
    "33559": [
      "hillsborough",
      "pasco"
    ],
    "33563": [
      "hillsborough"
    ],
    "33565": [
      "hillsborough"
    ],
    "33566": [
      "hillsborough"
    ],
    "33567": [
      "hillsborough"
    ],
    "33569": [
      "hillsborough"
    ],
    "33570": [
      "hillsborough"
    ],
    "33572": [
      "hillsborough"
    ],
    "33573": [
      "hillsborough"
    ],
    "33574": [
      "pasco"
    ],
    "33576": [
      "pasco"
    ],
    "33578": [
      "hillsborough"
    ],
    "33579": [
      "hillsborough"
    ],
    "33584": [
      "hillsborough"
    ],
    "33592": [
      "hillsborough"
    ],
    "33594": [
      "hillsborough"
    ],
    "33596": [
      "hillsborough"
    ],
    "33597": [
      "other",
      "pasco"
    ],
    "33598": [
      "hillsborough",
      "manatee"
    ],
    "33602": [
      "hillsborough"
    ],
    "33603": [
      "hillsborough"
    ],
    "33604": [
      "hillsborough"
    ],
    "33605": [
      "hillsborough"
    ],
    "33606": [
      "hillsborough"
    ],
    "33607": [
      "hillsborough"
    ],
    "33609": [
      "hillsborough"
    ],
    "33610": [
      "hillsborough"
    ],
    "33611": [
      "hillsborough"
    ],
    "33612": [
      "hillsborough"
    ],
    "33613": [
      "hillsborough"
    ],
    "33614": [
      "hillsborough"
    ],
    "33615": [
      "hillsborough"
    ],
    "33616": [
      "hillsborough"
    ],
    "33617": [
      "hillsborough"
    ],
    "33618": [
      "hillsborough"
    ],
    "33619": [
      "hillsborough"
    ],
    "33620": [
      "hillsborough"
    ],
    "33621": [
      "hillsborough"
    ],
    "33624": [
      "hillsborough"
    ],
    "33625": [
      "hillsborough"
    ],
    "33626": [
      "hillsborough"
    ],
    "33629": [
      "hillsborough"
    ],
    "33634": [
      "hillsborough"
    ],
    "33635": [
      "hillsborough"
    ],
    "33637": [
      "hillsborough"
    ],
    "33647": [
      "hillsborough"
    ],
    "33701": [
      "pinellas"
    ],
    "33702": [
      "pinellas"
    ],
    "33703": [
      "pinellas"
    ],
    "33704": [
      "pinellas"
    ],
    "33705": [
      "pinellas"
    ],
    "33706": [
      "pinellas"
    ],
    "33707": [
      "pinellas"
    ],
    "33708": [
      "pinellas"
    ],
    "33709": [
      "pinellas"
    ],
    "33710": [
      "pinellas"
    ],
    "33711": [
      "pinellas"
    ],
    "33712": [
      "pinellas"
    ],
    "33713": [
      "pinellas"
    ],
    "33714": [
      "pinellas"
    ],
    "33715": [
      "pinellas"
    ],
    "33716": [
      "pinellas"
    ],
    "33744": [
      "pinellas"
    ],
    "33755": [
      "pinellas"
    ],
    "33756": [
      "pinellas"
    ],
    "33759": [
      "pinellas"
    ],
    "33760": [
      "pinellas"
    ],
    "33761": [
      "pinellas"
    ],
    "33762": [
      "pinellas"
    ],
    "33763": [
      "pinellas"
    ],
    "33764": [
      "pinellas"
    ],
    "33765": [
      "pinellas"
    ],
    "33767": [
      "pinellas"
    ],
    "33770": [
      "pinellas"
    ],
    "33771": [
      "pinellas"
    ],
    "33772": [
      "pinellas"
    ],
    "33773": [
      "pinellas"
    ],
    "33774": [
      "pinellas"
    ],
    "33776": [
      "pinellas"
    ],
    "33777": [
      "pinellas"
    ],
    "33778": [
      "pinellas"
    ],
    "33781": [
      "pinellas"
    ],
    "33782": [
      "pinellas"
    ],
    "33785": [
      "pinellas"
    ],
    "33786": [
      "pinellas"
    ],
    "33901": [
      "lee"
    ],
    "33903": [
      "lee"
    ],
    "33904": [
      "lee"
    ],
    "33905": [
      "lee"
    ],
    "33907": [
      "lee"
    ],
    "33908": [
      "lee"
    ],
    "33909": [
      "lee"
    ],
    "33912": [
      "lee"
    ],
    "33913": [
      "lee"
    ],
    "33914": [
      "lee"
    ],
    "33916": [
      "lee"
    ],
    "33917": [
      "charlotte",
      "lee"
    ],
    "33919": [
      "lee"
    ],
    "33920": [
      "lee"
    ],
    "33921": [
      "charlotte",
      "lee"
    ],
    "33922": [
      "lee"
    ],
    "33924": [
      "lee"
    ],
    "33928": [
      "lee"
    ],
    "33931": [
      "lee"
    ],
    "33936": [
      "lee",
      "other"
    ],
    "33946": [
      "charlotte"
    ],
    "33947": [
      "charlotte"
    ],
    "33948": [
      "charlotte"
    ],
    "33950": [
      "charlotte"
    ],
    "33952": [
      "charlotte"
    ],
    "33953": [
      "charlotte"
    ],
    "33954": [
      "charlotte"
    ],
    "33955": [
      "charlotte",
      "lee"
    ],
    "33956": [
      "lee"
    ],
    "33957": [
      "lee"
    ],
    "33965": [
      "lee"
    ],
    "33966": [
      "lee"
    ],
    "33967": [
      "lee"
    ],
    "33971": [
      "lee"
    ],
    "33972": [
      "lee"
    ],
    "33973": [
      "lee"
    ],
    "33974": [
      "lee"
    ],
    "33976": [
      "lee"
    ],
    "33980": [
      "charlotte"
    ],
    "33981": [
      "charlotte"
    ],
    "33982": [
      "charlotte"
    ],
    "33983": [
      "charlotte"
    ],
    "33990": [
      "lee"
    ],
    "33991": [
      "lee"
    ],
    "33993": [
      "lee"
    ],
    "34101": [
      "collier"
    ],
    "34102": [
      "collier"
    ],
    "34103": [
      "collier"
    ],
    "34104": [
      "collier"
    ],
    "34105": [
      "collier"
    ],
    "34108": [
      "collier"
    ],
    "34109": [
      "collier"
    ],
    "34110": [
      "collier",
      "lee"
    ],
    "34112": [
      "collier"
    ],
    "34113": [
      "collier"
    ],
    "34114": [
      "collier"
    ],
    "34116": [
      "collier"
    ],
    "34117": [
      "collier"
    ],
    "34119": [
      "collier",
      "lee"
    ],
    "34120": [
      "collier"
    ],
    "34134": [
      "collier",
      "lee"
    ],
    "34135": [
      "collier",
      "lee"
    ],
    "34137": [
      "collier"
    ],
    "34138": [
      "collier"
    ],
    "34139": [
      "collier"
    ],
    "34140": [
      "collier"
    ],
    "34141": [
      "collier",
      "other"
    ],
    "34142": [
      "collier",
      "other"
    ],
    "34145": [
      "collier"
    ],
    "34201": [
      "manatee"
    ],
    "34202": [
      "manatee"
    ],
    "34203": [
      "manatee"
    ],
    "34205": [
      "manatee"
    ],
    "34207": [
      "manatee"
    ],
    "34208": [
      "manatee"
    ],
    "34209": [
      "manatee"
    ],
    "34210": [
      "manatee"
    ],
    "34211": [
      "manatee"
    ],
    "34212": [
      "manatee"
    ],
    "34215": [
      "manatee"
    ],
    "34216": [
      "manatee"
    ],
    "34217": [
      "manatee"
    ],
    "34219": [
      "manatee"
    ],
    "34221": [
      "manatee"
    ],
    "34222": [
      "manatee"
    ],
    "34223": [
      "charlotte",
      "sarasota"
    ],
    "34224": [
      "charlotte",
      "sarasota"
    ],
    "34228": [
      "manatee",
      "sarasota"
    ],
    "34229": [
      "sarasota"
    ],
    "34231": [
      "sarasota"
    ],
    "34232": [
      "sarasota"
    ],
    "34233": [
      "sarasota"
    ],
    "34234": [
      "sarasota"
    ],
    "34235": [
      "sarasota"
    ],
    "34236": [
      "sarasota"
    ],
    "34237": [
      "sarasota"
    ],
    "34238": [
      "sarasota"
    ],
    "34239": [
      "sarasota"
    ],
    "34240": [
      "manatee",
      "sarasota"
    ],
    "34241": [
      "sarasota"
    ],
    "34242": [
      "sarasota"
    ],
    "34243": [
      "manatee",
      "sarasota"
    ],
    "34250": [
      "manatee"
    ],
    "34251": [
      "manatee",
      "sarasota"
    ],
    "34266": [
      "other",
      "sarasota"
    ],
    "34269": [
      "charlotte",
      "other"
    ],
    "34275": [
      "sarasota"
    ],
    "34285": [
      "sarasota"
    ],
    "34286": [
      "sarasota"
    ],
    "34287": [
      "sarasota"
    ],
    "34288": [
      "sarasota"
    ],
    "34289": [
      "sarasota"
    ],
    "34291": [
      "sarasota"
    ],
    "34292": [
      "sarasota"
    ],
    "34293": [
      "sarasota"
    ],
    "34610": [
      "pasco"
    ],
    "34637": [
      "pasco"
    ],
    "34638": [
      "pasco"
    ],
    "34639": [
      "pasco"
    ],
    "34652": [
      "pasco"
    ],
    "34653": [
      "pasco"
    ],
    "34654": [
      "pasco"
    ],
    "34655": [
      "pasco"
    ],
    "34667": [
      "pasco"
    ],
    "34668": [
      "pasco"
    ],
    "34669": [
      "pasco"
    ],
    "34677": [
      "pinellas"
    ],
    "34679": [
      "pasco"
    ],
    "34681": [
      "pinellas"
    ],
    "34683": [
      "pinellas"
    ],
    "34684": [
      "pinellas"
    ],
    "34685": [
      "pinellas"
    ],
    "34688": [
      "pinellas"
    ],
    "34689": [
      "pinellas"
    ],
    "34690": [
      "pasco"
    ],
    "34691": [
      "pasco"
    ],
    "34695": [
      "pinellas"
    ],
    "34698": [
      "pinellas"
    ]
  },
  "providers": {
    "tampa": {
      "name": "City of Tampa Water Department",
      "period": "Utility guidance",
      "hardness": {
        "min": 140,
        "max": 300,
        "unit": "mg/L as CaCO3",
        "displayGpg": "8–17",
        "basis": "seasonal_range"
      },
      "treatment": "chloramine",
      "treatmentNote": "tampa_treatment",
      "sources": [
        {
          "title": "City of Tampa water hardness FAQ",
          "url": "https://www.tampa.gov/water/faq"
        },
        {
          "title": "City of Tampa disinfection information",
          "url": "https://www.tampa.gov/water/water-quality/water-system-maintenance"
        },
        {
          "title": "Current City of Tampa water quality report",
          "url": "https://www.tampa.gov/water/water-quality/current-water-quality-report"
        }
      ],
      "county": "hillsborough"
    },
    "manatee": {
      "name": "Manatee County Utilities",
      "period": "2025",
      "hardness": {
        "min": 106,
        "max": 279,
        "unit": "mg/L as CaCO3",
        "displayGpg": "6.2–16.3",
        "basis": "annual_range"
      },
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Manatee County 2025 additional water quality information",
          "url": "https://www.mymanatee.org/media/docs/default-source/utilities-documents/water-division-documents/additional-water-quality-information_2025.pdf"
        },
        {
          "title": "Manatee County 2025 water quality report",
          "url": "https://www.mymanatee.org/media/docs/default-source/utilities-documents/water-division-documents/2025-water-quality-report.pdf"
        }
      ],
      "county": "manatee"
    },
    "sarasota_city": {
      "name": "City of Sarasota Utilities",
      "period": "2025",
      "checked": "2026-10-03",
      "hardness": null,
      "treatment": "chlorine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "City of Sarasota 2025 water quality report",
          "url": "https://www.sarasotafl.gov/files/assets/city/v/2/utilities/documents/water-quality-report-consumer-quality-report.pdf"
        }
      ],
      "county": "sarasota"
    },
    "hillsborough_nw": {
      "name": "Hillsborough County · Northwest",
      "county": "hillsborough",
      "period": "2025",
      "hardness": null,
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Hillsborough County · Northwest · 2025 report",
          "url": "https://hcfl.gov/assets/bltc0b4205a15c30b0f/file"
        }
      ]
    },
    "hillsborough_sc": {
      "name": "Hillsborough County · South-Central",
      "county": "hillsborough",
      "period": "2025",
      "hardness": null,
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Hillsborough County · South-Central · 2025 report",
          "url": "https://hcfl.gov/assets/blt57f9322bed97a650/file"
        }
      ]
    },
    "pinellas": {
      "name": "Pinellas County Utilities",
      "county": "pinellas",
      "period": "2025 report; hardness from utility FAQ",
      "hardness": {
        "min": 171,
        "max": 256.5,
        "unit": "mg/L as CaCO3",
        "displayGpg": "10–15",
        "basis": "utility_guidance"
      },
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Pinellas County Utilities · 2025 report",
          "url": "https://pinellas.gov/wp-content/uploads/2026/06/CCR_Water_2025.pdf"
        },
        {
          "title": "Pinellas County hardness FAQ · utility guidance",
          "url": "https://pinellas.gov/water-faqs/"
        }
      ]
    },
    "pasco_regional": {
      "name": "Pasco County · Regional PWS 651-1361",
      "county": "pasco",
      "period": "2025",
      "hardness": null,
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Pasco County · Regional PWS 651-1361 · 2025 report",
          "url": "https://cms1files.revize.com/pasco/Documents/Services/Utilities/Water%20Quality%20Reports/WQR%202025/CCR_2025_Pasco_County_Regional_PWS-651.1361_(FDEP-Approved)(WCAG).pdf?t=202604200820350&t=202604200820350"
        }
      ]
    },
    "collier": {
      "name": "Collier County Water Sewer District",
      "county": "collier",
      "period": "2024 verified data; current report linked",
      "hardness": {
        "min": 42,
        "max": 94,
        "unit": "mg/L as CaCO3",
        "displayGpg": "2.4–5.5",
        "basis": "2024_reported_range"
      },
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "2024 county report · hardness page 4",
          "url": "https://www.collier.gov/files/assets/county/v/1/public-utilities/documents/water-division/2024-collier-county-water-quality-report-5-23-25.pdf"
        },
        {
          "title": "Current county report directory",
          "url": "https://www.collier.gov/Resident-Resources/Water-Services/Drinking-Water/Water-Quality-Report"
        }
      ]
    },
    "naples": {
      "name": "City of Naples Utilities",
      "county": "collier",
      "period": "2024 verified hardness; current report linked",
      "hardness": {
        "min": 58,
        "max": 102,
        "unit": "mg/L as CaCO3",
        "displayGpg": "3.4–6.0",
        "basis": "2024_reported_range"
      },
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "City of Naples · 2024 report",
          "url": "https://www.naplesgov.com/utilities/page/2024-ccr"
        },
        {
          "title": "City of Naples · current report directory",
          "url": "https://www.naplesgov.com/utilities/page/annual-water-quality-report"
        }
      ]
    },
    "lee": {
      "name": "Lee County Utilities",
      "county": "lee",
      "period": "2025",
      "hardness": null,
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Lee County Utilities · 2025 report",
          "url": "https://www.leegov.com/utilities/Documents/WaterQualityReport.pdf"
        }
      ]
    },
    "bonita_springs": {
      "name": "Bonita Springs Utilities",
      "county": "lee",
      "period": "Undated utility FAQ; checked October 2, 2026",
      "hardness": {
        "min": 80,
        "max": 100,
        "unit": "mg/L as CaCO3",
        "displayGpg": "4.7–5.8",
        "basis": "utility_guidance"
      },
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Bonita Springs Utilities · hardness and treatment FAQ",
          "url": "https://bsu.us/common-water-quality-concerns/"
        },
        {
          "title": "Bonita Springs Utilities · current report",
          "url": "https://bsu.us/current-water-quality-report/"
        }
      ]
    },
    "charlotte_peace": {
      "name": "Charlotte County Utilities · Peace River",
      "county": "charlotte",
      "period": "2025 report; hardness from undated utility guidance",
      "checked": "2026-10-03",
      "hardness": null,
      "hardnessGuidance": "charlotte",
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Charlotte County Utilities · Peace River · 2025 water quality report",
          "url": "https://www.charlottecountyfl.gov/file/529/Peace-River-Water-Quality-Report_2025.pdf"
        },
        {
          "title": "Utility hardness guidance · checked October 3, 2026",
          "url": "https://www.charlottecountyfl.gov/departments/utilities/utilities-faq.stml"
        }
      ]
    },
    "charlotte_burnt": {
      "name": "Charlotte County Utilities · Burnt Store",
      "county": "charlotte",
      "period": "2025 report; hardness from undated utility guidance",
      "checked": "2026-10-03",
      "hardness": null,
      "hardnessGuidance": "charlotte",
      "treatment": "chlorine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Charlotte County Utilities · Burnt Store · 2025 water quality report",
          "url": "https://www.charlottecountyfl.gov/file/529/Burnt-Store-Water-Quality-Report_2025.pdf"
        },
        {
          "title": "Utility hardness guidance · checked October 3, 2026",
          "url": "https://www.charlottecountyfl.gov/departments/utilities/utilities-faq.stml"
        }
      ]
    },
    "englewood": {
      "name": "Englewood Water District",
      "county": "charlotte",
      "period": "2025 report; hardness from undated utility guidance",
      "checked": "2026-10-03",
      "hardness": null,
      "hardnessGuidance": "englewood",
      "treatment": "chloramine",
      "treatmentNote": "annual_treatment",
      "sources": [
        {
          "title": "Englewood Water District · 2025 water quality report",
          "url": "https://englewoodwater.com/forms/CCR_2025.pdf"
        },
        {
          "title": "Utility hardness guidance · checked October 3, 2026",
          "url": "https://englewoodwater.com/lime-softening-plan/"
        }
      ],
      "counties": [
        "charlotte",
        "sarasota"
      ]
    }
  },
  "classificationSource": "https://www.usgs.gov/water-science-school/science/hardness-water",
  "decisionThresholdMgL": 121,
  "mgLPerGpg": 17.1,
  "regionalHardness": {
    "alachua": {
      "mgL": 44.0,
      "displayGpg": "2.6",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Alachua County",
      "source": "https://mytapwater.org/pws/fl2010946/gru-murphree-wtp/alachua-fl/",
      "reviewed": "2026-10-03"
    },
    "baker": {
      "mgL": 13.0,
      "displayGpg": "0.8",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Baker County",
      "source": "https://mytapwater.org/pws/fl2020531/dot-i-10-231-eastbound/baker-fl/",
      "reviewed": "2026-10-03"
    },
    "bay": {
      "mgL": 44.0,
      "displayGpg": "2.6",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Bay County",
      "source": "https://mytapwater.org/pws/fl1030050/bay-county-water-system/bay-fl/",
      "reviewed": "2026-10-03"
    },
    "bradford": {
      "mgL": 17.0,
      "displayGpg": "1",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Bradford County",
      "source": "https://mytapwater.org/pws/fl2040211/city-of-starke-wtp/bradford-fl/",
      "reviewed": "2026-10-03"
    },
    "brevard": {
      "mgL": 174.0,
      "displayGpg": "10.2",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Brevard County",
      "source": "https://mytapwater.org/pws/fl3050223/cocoa-city-of/brevard-fl/",
      "reviewed": "2026-10-03"
    },
    "broward": {
      "mgL": 250.0,
      "displayGpg": "14.6",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Broward County",
      "source": "https://mytapwater.org/pws/fl4060167/bcwws-1a/broward-fl/",
      "reviewed": "2026-10-03"
    },
    "calhoun": {
      "mgL": 89.0,
      "displayGpg": "5.2",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Calhoun County",
      "source": "https://mytapwater.org/pws/fl1070685/blountstown-city-of/calhoun-fl/",
      "reviewed": "2026-10-03"
    },
    "charlotte": {
      "mgL": 370.0,
      "displayGpg": "21.6",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Charlotte County",
      "source": "https://mytapwater.org/pws/fl5084100/charlotte-county-utilities/charlotte-fl/",
      "reviewed": "2026-10-03"
    },
    "citrus": {
      "mgL": 140.0,
      "displayGpg": "8.2",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Citrus County",
      "source": "https://mytapwater.org/pws/fl6090312/citrus-springs-pine-ridge/citrus-fl/",
      "reviewed": "2026-10-03"
    },
    "clay": {
      "mgL": 45.0,
      "displayGpg": "2.6",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Clay County",
      "source": "https://mytapwater.org/pws/fl2100741/orange-park-grid/clay-fl/",
      "reviewed": "2026-10-03"
    },
    "collier": {
      "mgL": 248.0,
      "displayGpg": "14.5",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Collier County",
      "source": "https://mytapwater.org/pws/fl5114069/collier-county-regional-wtp/collier-fl/",
      "reviewed": "2026-10-03"
    },
    "columbia": {
      "mgL": 81.0,
      "displayGpg": "4.7",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Columbia County",
      "source": "https://mytapwater.org/pws/fl2120630/city-of-lake-city-price-creek-wtp/columbia-fl/",
      "reviewed": "2026-10-03"
    },
    "desoto": {
      "mgL": 140.0,
      "displayGpg": "8.2",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "DeSoto County",
      "source": "https://mytapwater.org/pws/fl6144856/lake-suzy-subdivision/desoto-fl/",
      "reviewed": "2026-10-03"
    },
    "dixie": {
      "mgL": 158.0,
      "displayGpg": "9.2",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Dixie County",
      "source": "https://mytapwater.org/pws/fl2151140/suwannee-water-sewer-district/dixie-fl/",
      "reviewed": "2026-10-03"
    },
    "duval": {
      "mgL": 240.0,
      "displayGpg": "14",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Duval County",
      "source": "https://mytapwater.org/pws/fl2161328/jea-major-grid/duval-fl/",
      "reviewed": "2026-10-03"
    },
    "escambia": {
      "mgL": 14.0,
      "displayGpg": "0.8",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Escambia County",
      "source": "https://mytapwater.org/pws/fl1170525/emerald-coast-utilities-authority-ecua/escambia-fl/",
      "reviewed": "2026-10-03"
    },
    "flagler": {
      "mgL": 72.0,
      "displayGpg": "4.2",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Flagler County",
      "source": "https://mytapwater.org/pws/fl2180863/city-of-palm-coast-utility/flagler-fl/",
      "reviewed": "2026-10-03"
    },
    "franklin": {
      "mgL": 46.0,
      "displayGpg": "2.7",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Franklin County",
      "source": "https://mytapwater.org/pws/fl1190283/ft-gadsden-state-hist-site/franklin-fl/",
      "reviewed": "2026-10-03"
    },
    "gadsden": {
      "mgL": 31.0,
      "displayGpg": "1.8",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Gadsden County",
      "source": "https://mytapwater.org/pws/fl1200797/gadsden-co-regional-w-s/gadsden-fl/",
      "reviewed": "2026-10-03"
    },
    "gilchrist": {
      "mgL": 190.0,
      "displayGpg": "11.1",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Gilchrist County",
      "source": "https://mytapwater.org/pws/fl2211188/trenton-water-department/gilchrist-fl/",
      "reviewed": "2026-10-03"
    },
    "gulf": {
      "mgL": 46.0,
      "displayGpg": "2.7",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Gulf County",
      "source": "https://mytapwater.org/pws/fl1230734/wewahitchka-city-of/gulf-fl/",
      "reviewed": "2026-10-03"
    },
    "hamilton": {
      "mgL": 74.0,
      "displayGpg": "4.3",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Hamilton County",
      "source": "https://mytapwater.org/pws/fl2240570/city-of-jasper-wtp/hamilton-fl/",
      "reviewed": "2026-10-03"
    },
    "hardee": {
      "mgL": 110.0,
      "displayGpg": "6.4",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Hardee County",
      "source": "https://mytapwater.org/pws/fl6254799/wauchula-hills-wtp-hardee-county/hardee-fl/",
      "reviewed": "2026-10-03"
    },
    "hendry": {
      "mgL": 245.0,
      "displayGpg": "14.3",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Hendry County",
      "source": "https://mytapwater.org/pws/fl5260226/port-labelle/hendry-fl/",
      "reviewed": "2026-10-03"
    },
    "hernando": {
      "mgL": 138.0,
      "displayGpg": "8.1",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Hernando County",
      "source": "https://mytapwater.org/pws/fl6277059/hernando-co-utl-west/hernando-fl/",
      "reviewed": "2026-10-03"
    },
    "highlands": {
      "mgL": 34.0,
      "displayGpg": "2",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Highlands County",
      "source": "https://mytapwater.org/pws/fl6280250/sebring-water-sewer-system/highlands-fl/",
      "reviewed": "2026-10-03"
    },
    "hillsborough": {
      "mgL": 150.0,
      "displayGpg": "8.8",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Hillsborough County",
      "source": "https://mytapwater.org/pws/fl6290327/city-of-tampa-water-department/hillsborough-fl/",
      "reviewed": "2026-10-03"
    },
    "holmes": {
      "mgL": 31.0,
      "displayGpg": "1.8",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Holmes County",
      "source": "https://mytapwater.org/pws/fl1300083/bonifay-city-of-w-s/holmes-fl/",
      "reviewed": "2026-10-03"
    },
    "indian-river": {
      "mgL": 176.0,
      "displayGpg": "10.3",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Indian River County",
      "source": "https://mytapwater.org/pws/fl3314052/indian-river-county-utilities-2-wtps/indian-river-fl/",
      "reviewed": "2026-10-03"
    },
    "jackson": {
      "mgL": 59.0,
      "displayGpg": "3.5",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Jackson County",
      "source": "https://mytapwater.org/pws/fl1320449/marianna-city-of/jackson-fl/",
      "reviewed": "2026-10-03"
    },
    "jefferson": {
      "mgL": 130.0,
      "displayGpg": "7.6",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Jefferson County",
      "source": "https://mytapwater.org/pws/fl1330478/monticello-city-of/jefferson-fl/",
      "reviewed": "2026-10-03"
    },
    "lake": {
      "mgL": 136.0,
      "displayGpg": "8",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Lake County",
      "source": "https://mytapwater.org/pws/fl3350215/clermont-city-of-2-wps/lake-fl/",
      "reviewed": "2026-10-03"
    },
    "lee": {
      "mgL": 282.0,
      "displayGpg": "16.5",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Lee County",
      "source": "https://mytapwater.org/pws/fl5364048/lee-county-utilities/lee-fl/",
      "reviewed": "2026-10-03"
    },
    "leon": {
      "mgL": 42.0,
      "displayGpg": "2.5",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Leon County",
      "source": "https://mytapwater.org/pws/fl1370655/tallahassee-city-of/leon-fl/",
      "reviewed": "2026-10-03"
    },
    "levy": {
      "mgL": 200.0,
      "displayGpg": "11.7",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Levy County",
      "source": "https://mytapwater.org/pws/fl2380189/city-of-chiefland-wtp/levy-fl/",
      "reviewed": "2026-10-03"
    },
    "liberty": {
      "mgL": 11.0,
      "displayGpg": "0.6",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Liberty County",
      "source": "https://mytapwater.org/pws/fl1390087/bristol-city-of-water-system/liberty-fl/",
      "reviewed": "2026-10-03"
    },
    "madison": {
      "mgL": 70.0,
      "displayGpg": "4.1",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Madison County",
      "source": "https://mytapwater.org/pws/fl2400205/madison-water-department/madison-fl/",
      "reviewed": "2026-10-03"
    },
    "manatee": {
      "mgL": 138.0,
      "displayGpg": "8.1",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Manatee County",
      "source": "https://mytapwater.org/pws/fl6411132/manatee-county-utilities-dept/manatee-fl/",
      "reviewed": "2026-10-03"
    },
    "marion": {
      "mgL": 132.0,
      "displayGpg": "7.7",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Marion County",
      "source": "https://mytapwater.org/pws/fl6421144/west-side-consolidated/marion-fl/",
      "reviewed": "2026-10-03"
    },
    "martin": {
      "mgL": 190.0,
      "displayGpg": "11.1",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Martin County",
      "source": "https://mytapwater.org/pws/fl4431891/martin-co-utilities/martin-fl/",
      "reviewed": "2026-10-03"
    },
    "miami-dade": {
      "mgL": 230.0,
      "displayGpg": "13.5",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Miami-Dade County",
      "source": "https://mytapwater.org/pws/fl4130871/mdwasa-main-system/miami-dade-fl/",
      "reviewed": "2026-10-03"
    },
    "monroe": {
      "mgL": 180.0,
      "displayGpg": "10.5",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Monroe County",
      "source": "https://mytapwater.org/pws/fl5444047/fkaa-florida-keys-r-o-plants/monroe-fl/",
      "reviewed": "2026-10-03"
    },
    "nassau": {
      "mgL": 120.0,
      "displayGpg": "7",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Nassau County",
      "source": "https://mytapwater.org/pws/fl2450364/fernandina-beach-wtp/nassau-fl/",
      "reviewed": "2026-10-03"
    },
    "okaloosa": {
      "mgL": 19.0,
      "displayGpg": "1.1",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Okaloosa County",
      "source": "https://mytapwater.org/pws/fl1460506/okaloosa-co-wtr-swr-system/okaloosa-fl/",
      "reviewed": "2026-10-03"
    },
    "okeechobee": {
      "mgL": 61.0,
      "displayGpg": "3.6",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Okeechobee County",
      "source": "https://mytapwater.org/pws/fl4470257/okeechobee-utility-authority/okeechobee-fl/",
      "reviewed": "2026-10-03"
    },
    "orange": {
      "mgL": 68.0,
      "displayGpg": "4",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Orange County",
      "source": "https://mytapwater.org/pws/fl3480962/orlando-utilities-commission/orange-fl/",
      "reviewed": "2026-10-03"
    },
    "osceola": {
      "mgL": 52.0,
      "displayGpg": "3",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Osceola County",
      "source": "https://mytapwater.org/pws/fl3494429/toho-water-authority-poinciana-system/osceola-fl/",
      "reviewed": "2026-10-03"
    },
    "palm-beach": {
      "mgL": 200.0,
      "displayGpg": "11.7",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Palm Beach County",
      "source": "https://mytapwater.org/pws/fl4504393/palm-beach-county-water-utilities/palm-beach-fl/",
      "reviewed": "2026-10-03"
    },
    "pasco": {
      "mgL": 110.0,
      "displayGpg": "6.4",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Pasco County",
      "source": "https://mytapwater.org/pws/fl6511361/pcud-pasco-county-regional-pws/pasco-fl/",
      "reviewed": "2026-10-03"
    },
    "pinellas": {
      "mgL": 240.0,
      "displayGpg": "14",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Pinellas County",
      "source": "https://mytapwater.org/pws/fl6521405/pinellas-county-utilities/pinellas-fl/",
      "reviewed": "2026-10-03"
    },
    "polk": {
      "mgL": 69.0,
      "displayGpg": "4",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Polk County",
      "source": "https://mytapwater.org/pws/fl6531014/lakeland-city-of/polk-fl/",
      "reviewed": "2026-10-03"
    },
    "putnam": {
      "mgL": 182.0,
      "displayGpg": "10.6",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Putnam County",
      "source": "https://mytapwater.org/pws/fl2544260/r-c-willis-wtp-city-of-palatka/putnam-fl/",
      "reviewed": "2026-10-03"
    },
    "santa-rosa": {
      "mgL": 16.0,
      "displayGpg": "0.9",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Santa Rosa County",
      "source": "https://mytapwater.org/pws/fl1570349/holley-navarre-water-system/santa-rosa-fl/",
      "reviewed": "2026-10-03"
    },
    "sarasota": {
      "mgL": 350.0,
      "displayGpg": "20.5",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "Sarasota County",
      "source": "https://mytapwater.org/pws/fl6580326/sarasota-city-of/sarasota-fl/",
      "reviewed": "2026-10-03"
    },
    "seminole": {
      "mgL": 111.0,
      "displayGpg": "6.5",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Seminole County",
      "source": "https://mytapwater.org/pws/fl3594107/seminole-county-northwest/seminole-fl/",
      "reviewed": "2026-10-03"
    },
    "st-johns": {
      "mgL": 193.0,
      "displayGpg": "11.3",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "St. Johns County",
      "source": "https://mytapwater.org/pws/fl2554447/sjcu-cr214-mainland-wtp/st.-johns-fl/",
      "reviewed": "2026-10-03"
    },
    "st-lucie": {
      "mgL": 272.0,
      "displayGpg": "15.9",
      "classification": "very_hard",
      "basis": "regional_estimate",
      "region": "St. Lucie County",
      "source": "https://mytapwater.org/pws/fl4560954/port-st-lucie-utilities/st.-lucie-fl/",
      "reviewed": "2026-10-03"
    },
    "sumter": {
      "mgL": 140.0,
      "displayGpg": "8.2",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Sumter County",
      "source": "https://mytapwater.org/pws/fl6605012/north-sumter-utility-3wps/sumter-fl/",
      "reviewed": "2026-10-03"
    },
    "suwannee": {
      "mgL": 148.0,
      "displayGpg": "8.7",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Suwannee County",
      "source": "https://mytapwater.org/pws/fl2610203/live-oak-wtp/suwannee-fl/",
      "reviewed": "2026-10-03"
    },
    "volusia": {
      "mgL": 151.0,
      "displayGpg": "8.8",
      "classification": "hard",
      "basis": "regional_estimate",
      "region": "Volusia County",
      "source": "https://mytapwater.org/pws/fl3640275/daytona-beach-city-of/volusia-fl/",
      "reviewed": "2026-10-03"
    },
    "wakulla": {
      "mgL": 66.0,
      "displayGpg": "3.9",
      "classification": "moderately_hard",
      "basis": "regional_estimate",
      "region": "Wakulla County",
      "source": "https://mytapwater.org/pws/fl1650630/st-marks-city-of-water-sys/wakulla-fl/",
      "reviewed": "2026-10-03"
    },
    "walton": {
      "mgL": 18.0,
      "displayGpg": "1.1",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Walton County",
      "source": "https://mytapwater.org/pws/fl1660596/regional-utilities-water-system/walton-fl/",
      "reviewed": "2026-10-03"
    },
    "washington": {
      "mgL": 28.0,
      "displayGpg": "1.6",
      "classification": "soft",
      "basis": "regional_estimate",
      "region": "Washington County",
      "source": "https://mytapwater.org/pws/fl1670135/chipley-city-of/washington-fl/",
      "reviewed": "2026-10-03"
    }
  }
};
if(typeof module!=='undefined'&&module.exports)module.exports=ClearhouseWaterData;
